import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@portals/environments';
import { Options } from 'ngx-qrcode-styling';
@Component({
	selector: 'portals-jotto-pricing',
	templateUrl: './jotto-pricing.component.html',
	styleUrls: ['./jotto-pricing.component.scss'],
})
export class JottoPricingComponent implements OnInit {
	// stripe: any;
	qrcodeConfig: Options = {
		width: window.innerWidth * 0.12,
		height: window.innerWidth * 0.12,
		type: 'svg',
		image: '/assets/images/jotto-yellow.svg',
		dotsOptions: {
			color: '#491176',
			type: 'square',
		},
		backgroundOptions: {
			color: '#fbd354',
		},
		data: 'https://jotto.me/custom-plan',
		imageOptions: {
			crossOrigin: 'anonymous',
			margin: 0,
			hideBackgroundDots: false,
		},
	};
	constructor(private router: Router) {}

	navigateToDemo() {
		this.router.navigate(['/demo']);
	}
	getVariedConfig(width: number, height: number): Options {
		return {
			...this.qrcodeConfig,
			width: width,
			height: height,
		};
	}
	redirectToPaymentPro() {
		if (environment.production) {
			window.location.href = 'https://buy.stripe.com/dR6aEL5jl1XZeTmdQS';
		} else {
			window.location.href = 'https://buy.stripe.com/test_dR63ge4917mt8Y8dQQ';
		}
	}
	redirectToPaymentStarter() {
		if (environment.production) {
			window.location.href = 'https://buy.stripe.com/5kAeV1cLN0TVeTm28b';
		} else {
			window.location.href = 'https://buy.stripe.com/test_00g2caaxpfSZdeoaEF';
		}
	}
	// redirectToFreeTrial() { //free 30 day trial
	// 	window.location.href = 'https://buy.stripe.com/test_cN2aHk6cz7Ts6KQ144';
	// }
	sendEmail() {
		window.location.href = 'mailto:connect@jotto.me?subject=Contact%20Us';
	}

	ngOnInit(): void {}
}
